import { showWarning, clearAllAlerts } from './alertUtils';

export function createInactivityTimer(options = {}) {
  const timeout = options.timeout || 15000; // 15 saniye varsayılan
  const warningMessage = options.warningMessage || 'Uzun süredir hareketsizsiniz. Sayfayı aktif tutmak için herhangi bir yere tıklayın.';
  const onInactive = options.onInactive || null; // Yeni callback
  const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
  
  let timer = null;
  let warningShown = false;
  let isActive = false;

  // Uyarı
  function showWarningMessage() {
    if (warningShown || !isActive) return;
    
    warningShown = true;
    
    // Eğer onInactive callback'i varsa onu çağır, yoksa default uyarıyı göster
    if (onInactive && typeof onInactive === 'function') {
      onInactive();
    } else {
      showWarning(warningMessage, 0);
    }
  }

  // Event listener'ları ekle
  function addEventListeners() {
    events.forEach(event => {
      document.addEventListener(event, resetTimer, true);
    });
  }

  // Event listener'ları kaldır
  function removeEventListeners() {
    events.forEach(event => {
      document.removeEventListener(event, resetTimer, true);
    });
  }

  // Timer sıfırla
  function resetTimer() {
    if (!isActive) return;
    
    // Uyarı gösterilmişse gizle ve timer'ı yeniden başlat
    if (warningShown) {
      warningShown = false;
      clearAllAlerts();
    }
    
    // Timer'ı yeniden başlat
    if (timer) {
      clearTimeout(timer);
    }
    
    timer = setTimeout(() => {
      showWarningMessage();
    }, timeout);
  }

  // Timer'ı başlat
  function start() {
    stop(); // Önceki timer'ı temizle
    isActive = true;
    warningShown = false;
    
    timer = setTimeout(() => {
      showWarningMessage();
    }, timeout);

    addEventListeners();
  }

  // Timer durdur
  function stop() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    isActive = false;
    warningShown = false;
    removeEventListeners();
  }

  return {
    start,
    stop,
    timer
  };
}
